import { render, staticRenderFns } from "./services_home2.vue?vue&type=template&id=a5f55508&scoped=true"
import script from "./services_home2.vue?vue&type=script&lang=js"
export * from "./services_home2.vue?vue&type=script&lang=js"
import style0 from "./services_home2.vue?vue&type=style&index=0&id=a5f55508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f55508",
  null
  
)

export default component.exports